import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL =
  process.env.REACT_APP_SUPABASE_URL ||
  process.env.VITE_SUPABASE_URL ||
  '';

const SUPABASE_ANON_KEY =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  process.env.VITE_SUPABASE_ANON_KEY ||
  '';

export const SUPABASE_AUTH_STORAGE_KEY = 'n3bula-supabase-auth-v1';
const APP_SESSION_STORAGE_KEY = 'n3bula-session-v1';

function hasRealValue(value, placeholder) {
  return Boolean(value && value.trim() && !value.includes(placeholder));
}

export function isInvalidRefreshTokenError(error) {
  const message = String(error?.message || error || '').toLowerCase();
  return message.includes('invalid refresh token') || message.includes('refresh token not found');
}

function removeMatchingAuthKeys(storage) {
  if (!storage) return;
  const keysToRemove = [];
  for (let index = 0; index < storage.length; index += 1) {
    const key = storage.key(index);
    if (!key) continue;
    if (
      key === SUPABASE_AUTH_STORAGE_KEY ||
      key === APP_SESSION_STORAGE_KEY ||
      /^sb-.+-auth-token$/.test(key)
    ) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => storage.removeItem(key));
}

export function clearSupabaseAuthStorage() {
  if (typeof window === 'undefined') return;
  try {
    removeMatchingAuthKeys(window.localStorage);
    removeMatchingAuthKeys(window.sessionStorage);
  } catch (error) {
    console.warn('Unable to clear stale Supabase auth storage.', error);
  }
}

function installInvalidRefreshTokenGuard() {
  if (typeof window === 'undefined') return;
  if (window.__n3bulaInvalidRefreshTokenGuardInstalled) return;
  window.__n3bulaInvalidRefreshTokenGuardInstalled = true;

  const handleInvalidRefreshToken = (error) => {
    if (!isInvalidRefreshTokenError(error)) return false;
    clearSupabaseAuthStorage();
    if (window.location.pathname !== '/login') {
      window.location.assign('/login');
    }
    return true;
  };

  window.addEventListener('unhandledrejection', (event) => {
    if (handleInvalidRefreshToken(event.reason)) {
      event.preventDefault();
    }
  });

  window.addEventListener('error', (event) => {
    if (handleInvalidRefreshToken(event.error || event.message)) {
      event.preventDefault();
    }
  });
}

export const isSupabaseConfigured =
  hasRealValue(SUPABASE_URL, 'your_supabase_project_url') &&
  hasRealValue(SUPABASE_ANON_KEY, 'your_supabase_anon_key');

installInvalidRefreshTokenGuard();

export const supabase = isSupabaseConfigured
  ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
      auth: {
        storageKey: SUPABASE_AUTH_STORAGE_KEY,
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;
